import React from "react";

const Footer = () => {
  return (
    <div className="py-10 bg-gray-200">
      <p className="text-center text-gray-400 font-bold text-sm">
        &copy; Youth Developer Conference 2020
      </p>
    </div>
  );
};

export default Footer;
